<template>
  <v-sheet>
    <v-app-bar
      app
      height="54px"
      color="grey lighten-4"
      elevation="1"
      clipped-left
    >
      <v-menu z-index="4000" open-on-hover>
        <template v-slot:activator="{ on: menu, attrs }">
          <v-btn
            fab
            x-small
            color="orange"
            elevation="2"
            v-bind="attrs"
            v-on="{ ...menu }"
          >
            <span style="font-weight: bold; font-size: 20px; color: white; -webkit-text-stroke: 1px #ffc979; ">S</span>
          </v-btn>
        </template>
        <v-card>
          <MainMenu />
        </v-card>
      </v-menu>

      <v-toolbar-title>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">
              {{ $t("view.plan.title") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-toolbar-title>

      <v-spacer />

      <v-menu ref="monthMenu"
              v-model="monthMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              nudge-left="100"
              max-width="290px"
              min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            style="font-weight: bold; margin-top: 4px; margin-right: 5px;"
            color="transparent"
            v-bind="attrs"
            v-on="on"
          >{{ formatMonth(month) }}
          </v-chip>
        </template>
        <v-date-picker
          v-model="month"
          @input="monthMenu = false"
          type="month"
          no-title
          scrollable
          :locale="getIsoLocale()"
        >
        </v-date-picker>
      </v-menu>

      <v-text-field
        :label="$t('common.fast_filter')"
        prepend-icon="mdi-filter"
        clearable
        v-model="filter"
        hide-details
        dense
        flat
        solo
        background-color="transparent"
        class="pl-1 pr-4 hidden-sm-and-down transparent-background"
        style="max-width: 180px"
      >
      </v-text-field>

      <v-tooltip bottom open-delay="500">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            :color="(showAll) ? 'primary' : 'default'"
            @click="actionShowAll"
          >
            <v-icon>border_all</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("view.plan.show-all") }}</span>
      </v-tooltip>

      <v-tooltip bottom open-delay="500">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            @click="actionZoomAll"
          >
            <v-icon>crop_free</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("view.plan.zoom-month") }}</span>
      </v-tooltip>

      <v-tooltip bottom open-delay="500">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            @click="actionZoomIn"
          >
            <v-icon>zoom_in</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("view.plan.zoom-in") }}</span>
      </v-tooltip>

      <v-tooltip bottom open-delay="500">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            @click="actionZoomOut"
          >
            <v-icon>zoom_out</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("view.plan.zoom-out") }}</span>
      </v-tooltip>

      <v-menu v-model="saveMenu" offset-y>
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip bottom open-delay="500">
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>save</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("view.plan.save") }}</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item link @click="saveToPNG">
            <v-list-item-title>{{ $t("view.plan.save-png") }}</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="saveToPDF">
            <v-list-item-title>{{ $t("view.plan.save-pdf") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </v-app-bar>

    <div style="width: 100%; max-height: calc(100vh - 54px)">
      <div ref="timeline"></div>
    </div>

    <div
      id="tooltip"
      class="timeline-tooltip"
      v-if="tooltipVisible"
      :style="tooltipStyle"
      v-html="tooltipConent"
    />

    <!-- context menu -->
    <v-menu
      v-model="contextMenu"
      :close-on-content-click="false"
      :nudge-left="0"
      :nudge-top="0"
      :offset-x="true"
      :offset-y="true"
      :position-x="contextMenuX"
      :position-y="contextMenuY"
      absolute
    >
      <v-list>
        <template v-for="item in contextItems">
          <v-list-item v-if="item.divider === undefined" :key="item.id"
                       link
                       @click="handleContextAction(item.id)">
            <v-list-item-icon class="mr-2">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
          <v-divider v-else :key="'div-' + item.id" class="mx-2" />
        </template>
      </v-list>
    </v-menu>

  </v-sheet>
</template>

<script>
import MainMenu from "@/components/MainMenu";
import { Timeline } from "vis-timeline/esnext";
import { DataSet } from "vis-data";
import "vis-timeline/styles/vis-timeline-graph2d.min.css";
import i18n from "@/plugins/i18n";
import { DateTime, Duration } from "luxon";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import utils from "@/utils";

export default {
  name: "PlanView`",

  components: {
    MainMenu
  },

  data() {
    return {
      timeline: null,
      groups: null,
      items: null,
      refresh: false,
      filter: null,
      showAll: true,
      monthMenu: false,
      month: DateTime.now().toFormat("yyyy-M"),
      saveMenu: false,

      contextMenu: false,
      contextMenuX: null,
      contextMenuY: null,
      contextVehicleId: null,
      contextContractId: null,
      contextItems: [],

      eventLastObject: null,
      eventLastId: null,

      tooltipVisible: false,
      tooltipConent: "",
      tooltipStyle: {
        top: "0px",
        left: "0px",
        display: "none"
      },

      vehicleActions: [
        {
          id: "map-vehicle",
          title: this.$t("view.plan.context-menu.vehicle.map-vehicle"),
          icon: "mdi-crosshairs-gps"
        },
        {
          id: "map-contracts",
          title: this.$t("view.plan.context-menu.vehicle.map-contracts"),
          icon: "widgets"
        },
        {
          id: "report-logbook",
          title: this.$t("view.plan.context-menu.vehicle.report-logbook"),
          icon: "mdi-file-chart-outline"
        },
        {
          id: "report-performance",
          title: this.$t("view.plan.context-menu.vehicle.report-performance"),
          icon: "mdi-file-chart"
        }
      ],

      contractActions: [
        {
          id: "map-contract",
          title: this.$t("view.plan.context-menu.contract.map"),
          icon: "public"
        },
        {
          id: "edit-contract",
          title: this.$t("view.plan.context-menu.contract.edit"),
          icon: "edit"
        },
        {
          id: "divider-1",
          divider: true
        }
      ]
    };
  },

  computed: {},

  methods: {
    getIsoLocale() {
      return i18n.messages[i18n.locale].lang.iso;
    },

    getCurrenDateInMS() {
      return DateTime.now().startOf("day").plus({ "days": 1 }).toISO();
    },

    formatMonth(date) {
      if (date !== null)
        return DateTime.fromFormat(date, "yyyy-M").toLocaleString({ month: "long", year: "numeric" });
      else
        return "";
    },

    close() {
      this.$router.close({ name: "map" });
    },

    saveToPNG() {
      html2canvas(this.$refs.timeline).then((canvas) => {
        const link = document.createElement("a");
        link.download = "timeline.png";
        link.href = canvas.toDataURL("image/png");
        link.click();
      });
    },

    saveToPDF() {
      html2canvas(this.$refs.timeline).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("landscape", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("timeline.pdf");
      });
    },

    refreshData() {
      this.$store.dispatch("data/fetchContracts", {
        from: DateTime.fromFormat(this.month, "yyyy-M").startOf("month").toFormat("yyyy-MM-dd'T00:00:00'"),
        to: DateTime.fromFormat(this.month, "yyyy-M").endOf("month").toFormat("yyyy-MM-dd'T23:59:59'"),
        groupset: this.$store.state.groupsets.groupset
      }).then(
        (response) => {
          this.monthMenu = false;
          this.saveMenu = false;
          const groups = [];
          const items = [];

          this.$store.state.online.vehicles.forEach(vehicle => {
            groups.push({
              id: vehicle.vehicleId,
              content: vehicle.numericPlate,
              vehicle: vehicle
            });
          });

          if (response.data.content !== null) {
            const now = DateTime.now();

            response.data.content.forEach(contract => {
              let state;

              if (now < DateTime.fromISO(contract.fromTimestamp))
                state = "planned";
              else if (now <= DateTime.fromISO(contract.toTimestamp))
                state = "active";
              else if (contract.actualDuration !== null && contract.actualDuration > 0)
                state = "done";
              else
                state = "unrealized";

              items.push({
                id: contract.contractId,
                group: contract.vehicleId,
                start: contract.fromTimestamp,
                end: contract.toTimestamp,
                className: state,
                content: contract.name,
                contract: contract
              });
            });
          }

          // filter
          if (!this.showAll && this.filter !== null && this.filter.trim().length > 0) {
            const ids = new Set();
            const search = this.filter.trim().toLowerCase();
            items.forEach(item => ids.add(item.group));
            groups.forEach(group => group["visible"] = ids.has(group.id) && group.content.toLowerCase().indexOf(search) !== -1);
          } else if (!this.showAll) {
            const ids = new Set();
            items.forEach(item => ids.add(item.group));
            groups.forEach(group => group["visible"] = ids.has(group.id));
          } else if (this.filter !== null && this.filter.trim().length > 0) {
            const search = this.filter.trim().toLowerCase();
            groups.forEach(group => group["visible"] = group.content.toLowerCase().indexOf(search) !== -1);
          }

          // uloženi do stavajícího timeline
          this.groups.clear();
          this.items.clear();

          this.groups.add(groups);
          this.items.add(items);

          // nastaveni options
          this.timeline.setOptions({
            start: DateTime.fromFormat(this.month, "yyyy-M").startOf("month").toISO(),
            end: DateTime.fromFormat(this.month, "yyyy-M").endOf("month").toISO(),
            min: DateTime.fromFormat(this.month, "yyyy-M").startOf("month").toISO(),
            max: DateTime.fromFormat(this.month, "yyyy-M").endOf("month").toISO()
          });
        });
    },

    filterItems() {
      if (this.showAll && (this.filter === null || this.filter.trim().length === 0)) {
        this.groups.forEach(group => this.groups.update({ id: group.id, visible: true }));
      } else if (!this.showAll && this.filter !== null && this.filter.trim().length > 0) {
        const ids = new Set();
        const search = this.filter.trim().toLowerCase();
        this.items.forEach(item => ids.add(item.group));
        this.groups.forEach(group => this.groups.update({
          id: group.id,
          visible: ids.has(group.id) && group.content.toLowerCase().indexOf(search) !== -1
        }));
      } else if (!this.showAll) {
        const ids = new Set();
        this.items.forEach(item => ids.add(item.group));
        this.groups.forEach(group => this.groups.update({ id: group.id, visible: ids.has(group.id) }));
      } else {
        const search = this.filter.trim().toLowerCase();
        this.groups.forEach(group => this.groups.update({
          id: group.id,
          visible: group.content.toLowerCase().indexOf(search) !== -1
        }));
      }
    },

    actionShowAll() {
      this.showAll = !this.showAll;
      this.filterItems();
    },

    actionZoomAll() {
      this.timeline.setWindow(
        DateTime.fromFormat(this.month, "yyyy-M").startOf("month").toFormat("yyyy-MM-dd"),
        DateTime.fromFormat(this.month, "yyyy-M").plus({ months: 1 })
          .startOf("month").toFormat("yyyy-MM-dd"));
    },

    actionZoomIn() {
      const range = this.timeline.getWindow();
      const start = range.start.getTime();
      const end = range.end.getTime();
      const zoomFactor = 0.5; // Přiblížení o 50 %
      const newStart = new Date((start + end) / 2 - (end - start) * zoomFactor / 2);
      const newEnd = new Date((start + end) / 2 + (end - start) * zoomFactor / 2);
      this.timeline.setWindow(newStart, newEnd);
    },

    actionZoomOut() {
      const range = this.timeline.getWindow();
      const start = range.start.getTime();
      const end = range.end.getTime();
      const zoomFactor = 2; // Oddálení o 200 %
      const newStart = new Date((start + end) / 2 - (end - start) * zoomFactor / 2);
      const newEnd = new Date((start + end) / 2 + (end - start) * zoomFactor / 2);
      this.timeline.setWindow(newStart, newEnd);
    },

    clickTimelineAction() {
      if (this.contextMenu)
        this.contextMenu = false;
      if (this.monthMenu)
        this.monthMenu = false;
      if (this.saveMenu)
        this.saveMenu = false;
    },

    doubleClick(event) {
      const { item, group } = event;

      if (group !== null && item !== null) {
        this.$router.push({
          name: "map/contracts",
          params: { id: group },
          query: { month: this.month, contract: item }
        });
      } else if (group !== null) {
        this.$router.push({
          name: "map/contracts",
          params: { id: group },
          query: { month: this.month }
        });
      }
    },

    showContextMenu(event) {
      const { item, group } = event;

      this.contextVehicleId = group;
      this.contextContractId = item;

      this.contextItems = [];

      if (item !== null)
        this.contextItems.push(...this.contractActions);

      if (group !== null)
        this.contextItems.push(...this.vehicleActions);

      // Zabráníme klasické nabídce prohlížeče
      event.event.preventDefault();

      // Nastavení pozice menu dle souřadnic kliknutí
      this.contextMenuX = event.event.clientX;
      this.contextMenuY = event.event.clientY;

      this.tooltipVisible = false;
      // Zobrazení menu
      this.contextMenu = true;
    },

    handleContextAction(action) {
      switch (action) {
        case "map-vehicle":
          this.$router.push({ name: "map/vehicle", params: { id: this.contextVehicleId } });
          break;

        case "map-contracts":
          this.$router.push({
            name: "map/contracts",
            params: { id: this.contextVehicleId },
            query: { month: this.month }
          });
          break;

        case "report-logbook":
          this.$router.push({
            name: "report/logbook",
            query: {
              vehicleId: this.contextVehicleId,
              period: "month-one|" + DateTime.fromFormat(this.month, "yyyy-M").startOf("month").toFormat("yyyy-MM")
            }
          });
          break;

        case "report-performance":
          this.$router.push({
            name: "report/performance",
            query: {
              vehicleId: this.contextVehicleId,
              period: "month-one|" + DateTime.fromFormat(this.month, "yyyy-M").startOf("month").toFormat("yyyy-MM")
            }
          });
          break;

        case "map-contract":
          this.$router.push({
            name: "map/contracts",
            params: { id: this.contextVehicleId },
            query: { month: this.month, contract: this.contextContractId }
          });
          break;

        case "edit-contract":
          this.$router.push({
            name: "data/contract",
            params: { id: this.contextContractId }
          });
          break;
      }

      this.contextMenu = false;
    },

    contractBlockHtml(contract) {
      const c = contract.contract;
      let dist = "";

      if (c.plannedDistance !== null && c.actualDistance !== null) {
        dist = "<span class=\"contract-item-distance\">"
          + utils.formatDistance(c.actualDistance) + " / " + utils.formatDistance(c.plannedDistance) + "</span>";
      } else if (c.actualDistance !== null) {
        dist = "<span class=\"contract-item-distance\">" + utils.formatDistance(c.actualDistance) + "</span>";
      } else if (c.plannedDistance !== null) {
        dist = "<span class=\"contract-item-distance\">- / " + utils.formatDistance(c.plannedDistance) + "</span>";
      }

      let html = "<div><span class=\"contract-item-title\">" + c.name + "</span>" + dist + "</div>";
      if (c.subject !== null && c.subject.name !== null) {
        html += "<div class=\"contract-item-subject\">" + c.subject.name + "</div>";
      } else {
        html += "<div class=\"contract-item-subject\">-</div>";
      }

      return html;
    },

    contractTooltipHtml(contract) {
      const c = contract.contract;

      let html = "<div class=\"contract-tooltip-title\">" + c.name + "</div>";

      if (c.subject !== null && c.subject.name !== null) {
        html += "<div class=\"contract-tooltip-subject\">" + c.subject.name + "</div>";
      }

      html += "<hr class=\"contract-tooltip-divider\"/>";

      html += "<div>" + DateTime.fromISO(c.fromTimestamp).toLocaleString(DateTime.DATETIME_SHORT) + "</div>";
      html += "<div>" + DateTime.fromISO(c.toTimestamp).toLocaleString(DateTime.DATETIME_SHORT) + "</div>";

      if (c.plannedDistance !== null && c.actualDistance !== null) {
        html += "<hr class=\"contract-tooltip-divider\"/>";
        html += "<div class=\"contract-tooltip-distance\">"
          + utils.formatDistance(c.actualDistance) + " / " + utils.formatDistance(c.plannedDistance) + "</div>";
      } else if (c.actualDistance !== null) {
        html += "<hr class=\"contract-tooltip-divider\"/>";
        html += "<div class=\"contract-tooltip-distance\">" + utils.formatDistance(c.actualDistance) + "</div>";
      } else if (c.plannedDistance !== null) {
        html += "<hr class=\"contract-tooltip-divider\"/>";
        html += "<div class=\"contract-tooltip-distance\">- / " + utils.formatDistance(c.plannedDistance) + "</div>";
      }

      if (c.plannedDuration !== null && c.actualDuration !== null) {
        html += "<div class=\"contract-tooltip-distance\">"
          + this.formatDuration(c.actualDuration) + " / " + this.formatDuration(c.plannedDuration) + "</div>";
      } else if (c.actualDuration !== null) {
        html += "<div class=\"contract-tooltip-distance\">" + this.formatDuration(c.actualDuration) + "</div>";
      } else if (c.plannedDuration !== null) {
        html += "<div class=\"contract-tooltip-distance\">- / " + this.formatDuration(c.plannedDuration) + "</div>";
      }

      return html;
    },

    vehicleTooltipHtml(vehicle) {
      const v = vehicle.vehicle;

      let html = "<div class=\"contract-tooltip-title\">" + v.numericPlate + "</div>";

      if (v.name !== null) {
        html += "<div>" + v.name + "</div>";
      }

      if (v.typeCode !== null) {
        html += "<div>" + this.$t("enum.vehicle_type." + v.typeCode) + "</div>";
      }

      return html;
    },

    formatDuration(duration) {
      if (duration !== null)
        return Duration.fromObject({ seconds: duration }).toFormat("h'h' m'm'");
      else
        return "-";
    },

    updateUrl() {
      this.$router.replace({
        name: "plan", query: {
          ...this.$route.query,
          month: this.month
        }
      }).catch(() => {
      });
    }
  },

  watch: {
    filter: function() {
      this.filterItems();
    },

    month: function() {
      this.refreshData();
      this.updateUrl();
    },

    "$store.state.online.vehicles": function() {
      if (this.refresh) {
        this.refreshData();
        this.refresh = false;
      }
    },

    "$store.state.auth.company": function() {
      this.refresh = true;
    },

    "$store.state.groupsets.groupset": function() {
      this.refresh = true;
    }
  },

  mounted() {
    if (this.$route.query["month"] !== undefined)
      this.month = this.$route.query["month"];
    else {
      this.month = DateTime.now().toFormat("yyyy-M");
      this.updateUrl();
    }

    // Příprava dat
    const container = this.$refs.timeline;

    this.groups = new DataSet([]);
    this.items = new DataSet([]);

    // Možnosti nastavení časové osy
    const options = {
      stack: false,
      start: DateTime.fromFormat(this.month, "yyyy-M").startOf("month").toISO(),
      end: DateTime.fromFormat(this.month, "yyyy-M").endOf("month").toISO(),
      min: DateTime.fromFormat(this.month, "yyyy-M").startOf("month").toISO(),
      max: DateTime.fromFormat(this.month, "yyyy-M").endOf("month").toISO(),
      editable: false,
      selectable: false,
      zoomKey: "ctrlKey",
      zoomMin: 1000 * 60 * 60 * 12,
      verticalScroll: true,
      horizontalScroll: true,
      maxHeight: "calc(100vh - 54px)",
      groupHeightMode: "fixed",
      orientation: {
        axis: "top",
        item: "top"
      },
      template: this.contractBlockHtml,
      xss: {
        disabled: false,
        filterOptions: {
          whiteList: { div: ["class", "style"], span: ["class", "style"], hr: ["class"] }
        }
      }
    };

    this.timeline = new Timeline(container, this.items, this.groups, options);

    this.timeline.on("contextmenu", this.showContextMenu);
    this.timeline.on("click", this.clickTimelineAction);
    this.timeline.on("doubleClick", this.doubleClick);

    container.addEventListener("mouseleave", () => {
      if (this.tooltipVisible) {
        this.tooltipVisible = false;
        this.tooltipStyle = {
          ...this.tooltipStyle,
          display: "none"
        };
      }
    });

    this.timeline.on("mouseOver", (props) => {
      if (props.what === "group-label" && !this.contextMenu) {
        const item = this.groups.get(props.group);
        this.tooltipConent = this.vehicleTooltipHtml(item);
        this.tooltipVisible = true;
      } else if (props.what === "item" && !this.contextMenu) {
        const item = this.items.get(props.item);
        this.tooltipConent = this.contractTooltipHtml(item);
        this.tooltipVisible = true;
      } else {
        this.tooltipVisible = false;
        this.tooltipStyle = {
          ...this.tooltipStyle,
          display: "none"
        };
      }
    });

    this.timeline.on("mouseMove", (props) => {
      if (this.tooltipVisible) {
        const tooltip = document.getElementById("tooltip");
        const tooltipWidth = tooltip.offsetWidth;
        const tooltipHeight = tooltip.offsetHeight;

        const mouseX = props.event.pageX;
        const mouseY = props.event.pageY - 54;

        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        let left = mouseX + 10;
        let top = mouseY + 10;

        // Kontrola hranic (posun tooltipu zpět na obrazovku)
        if (mouseX + tooltipWidth + 10 > viewportWidth) {
          left = mouseX - tooltipWidth - 10; // Posuneme na levou stranu
        }
        if (mouseY + tooltipHeight + 10 > viewportHeight) {
          top = mouseY - tooltipHeight - 10; // Posuneme nad kurzor
        }

        this.tooltipStyle = {
          top: `${top}px`,
          left: `${left}px`,
          display: "block"
        };
      }
    });

    this.timeline.on("rangechanged", () => {
      if (!this.timeline.initialDrawDone)
        this.timeline.redraw();
    });

    this.refreshData();
  }
};
</script>

<style>
.vis-label {
  font-weight: bold;
}

.vis-item {
  line-height: 1.25;
  /*  box-shadow: 2px 2px 2px #dcdcdc;*/
}

.vis-item-content {
  padding: 2px 4px !important;
}

.vis-item.active {
  background-color: #afdeac !important;
  border-color: #9ac397 !important;
}

.vis-item.planned {
  background-color: #d4dcf6 !important;
  border-color: #c0c7de !important;
}

.vis-item.done {
  background-color: #d8d8b6 !important;
  border-color: #cccca2 !important;
}

.vis-item.unrealized {
  background-color: #ffcaca !important;
  border-color: #dcaeae !important;
}

.contract-item-title {
  display: inline-block;
  font-size: 80%;
  font-weight: bold;
  max-width: calc(100vh / 3);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: bottom;
  padding-bottom: 1px;
}

.contract-item-subject {
  font-size: 70%;
  font-style: italic;
}

.contract-item-distance {
  font-size: 75%;
  margin-left: 10px;
  color: blue
}

.timeline-tooltip {
  position: absolute;
  border-radius: 4px;
  white-space: nowrap;
  pointer-events: none;
  z-index: 9999;
  font-family: Roboto, sans-serif;
  font-size: 80%;
  background-color: #7d7d7d;
  border-color: #7d7d7d;
  color: #eeeeee;
  padding: 4px 6px;
}

.contract-tooltip-divider {
  border: none;
  box-shadow: none;
  height: 1px;
  background-color: #9e9e9e;
  margin: 2px 0;
}

.contract-tooltip-title {
  font-weight: bold;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.contract-tooltip-subject {
  font-style: italic;
}

.contract-tooltip-distance {
  color: lightblue
}
</style>